export const isThemeHexColor = (value) => typeof value === "string" && /^#[0-9a-f]{6}$/i.test(value);
const channels = (color) => [
    Number.parseInt(color.slice(1, 3), 16),
    Number.parseInt(color.slice(3, 5), 16),
    Number.parseInt(color.slice(5, 7), 16),
];
const luminance = (color) => {
    const [red, green, blue] = channels(color).map((value) => {
        const normalized = value / 255;
        return normalized <= 0.03928
            ? normalized / 12.92
            : ((normalized + 0.055) / 1.055) ** 2.4;
    });
    return ((red ?? 0) * 0.2126 +
        (green ?? 0) * 0.7152 +
        (blue ?? 0) * 0.0722);
};
export const themeContrastRatio = (foreground, background) => {
    if (!isThemeHexColor(foreground) || !isThemeHexColor(background))
        return 0;
    const foregroundLuminance = luminance(foreground);
    const backgroundLuminance = luminance(background);
    const lighter = Math.max(foregroundLuminance, backgroundLuminance);
    const darker = Math.min(foregroundLuminance, backgroundLuminance);
    return (lighter + 0.05) / (darker + 0.05);
};
export const mixThemeColor = (color, target, weight) => {
    if (!isThemeHexColor(color))
        return color;
    const source = channels(color);
    const destination = channels(target);
    const mixed = source.map((value, index) => {
        const destinationValue = destination[index] ?? value;
        return Math.round(value + (destinationValue - value) * weight);
    });
    return `#${mixed
        .map((value) => value.toString(16).padStart(2, "0"))
        .join("")}`;
};
export const themeColorDistance = (first, second) => {
    if (!isThemeHexColor(first) || !isThemeHexColor(second))
        return 0;
    const firstChannels = channels(first);
    const secondChannels = channels(second);
    return Math.sqrt(firstChannels.reduce((total, value, index) => {
        const difference = value - (secondChannels[index] ?? value);
        return total + difference ** 2;
    }, 0));
};
//# sourceMappingURL=color.js.map